import { useState, useEffect } from "react";
import styles from "./InternationalPartnership.module.css";
import ktc from "../../../assets/images/school_programmes/worldwideimg.png";
import internationalPartnerships1 from "../../../assets/images/school_programmes/InternationalPartnerships1.png";
import ktcgroup from "../../../assets/images/school_programmes/ktcgroup.png";
import internationalPartnerships2 from "../../../assets/images/school_programmes/InternationalPartnerships2.png";

import award1 from "../../../assets/images/achivements/awards/1.png";
import award2 from "../../../assets/images/achivements/awards/2.png";
import award3 from "../../../assets/images/achivements/awards/3.png";
import award4 from "../../../assets/images/achivements/awards/4.png";
import award5 from "../../../assets/images/achivements/awards/5.png";
import award6 from "../../../assets/images/achivements/awards/6.png";
import award7 from "../../../assets/images/achivements/awards/7.png";

const InternationalPartnership = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const awards = [
    { image: award1, name: "Best EdTech Startup 2023" },
    { image: award2, name: "Innovation in STEM Education" },
    { image: award3, name: "Excellence in Teaching" },
    { image: award4, name: "Outstanding Contribution to Education" },
    { image: award5, name: "Best STEM Initiative" },
    { image: award6, name: "Innovative Teaching Practices" },
    { image: award7, name: "Leadership in Education" },
  ];

  return (
    <section className={styles.partnership}>
      <div className={styles.container}>
        <h2 data-aos="fade-up">
          Global <span>Partnerships & Achievements</span>
        </h2>

        <div className={styles.partnershipContent}>
          <div
            className={styles.ktcPartnership}
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <div className={styles.worldwidePresence}>
              <span className={styles.borderbottom}>
                Worldwide Presence Of MiCHiTECH, KTC Group
              </span>
              <div className={styles.logos}>
                <img src={ktc} alt="KTC Group Partnerships" />
              </div>
              <div className={styles.containerktc}>
                {isMobile ? (
                  // Mobile Layout
                  <>
                    <div
                      className={styles.ktctitle1}
                      data-aos="fade-up"
                      data-aos-delay="200"
                    >
                      <span className={styles.borderbottom}>
                        KTC Group Of Schools Across the Globe
                      </span>
                    </div>
                    <div
                      className={styles.imglayer1}
                      data-aos="fade-up"
                      data-aos-delay="300"
                    >
                      <img src={ktcgroup} alt="International Partnerships" />
                    </div>
                    <div
                      className={styles.ktctitle2}
                      data-aos="fade-up"
                      data-aos-delay="400"
                    >
                      <span className={styles.borderbottom}>
                        Partnership with Japanese education leader MiChiTech
                        (KTC Holdings, Japan)
                      </span>
                    </div>
                    <div
                      className={styles.imglayer2}
                      data-aos="fade-up"
                      data-aos-delay="500"
                    >
                      <img
                        src={internationalPartnerships2}
                        alt="International Partnerships"
                      />
                    </div>
                  </>
                ) : (
                  // Desktop Layout
                  <>
                    <div
                      className={styles.ktctitles}
                      data-aos="fade-up"
                      data-aos-delay="200"
                    >
                      <div className={styles.ktctitle1}>
                        <span className={styles.borderbottom}>
                          KTC Group Of Schools Across the Globe
                        </span>
                      </div>
                      <div className={styles.ktctitle2}>
                        <span className={styles.borderbottom}>
                          Partnership with Japanese education leader MiChiTech
                          (KTC Holdings, Japan)
                        </span>
                      </div>
                    </div>
                    <div className={styles.imglayer}>
                      <div
                        className={styles.imglayer1}
                        data-aos="fade-right"
                        data-aos-delay="300"
                      >
                        <img src={ktcgroup} alt="International Partnerships" />
                      </div>
                      <div
                        className={styles.imglayer2}
                        data-aos="fade-left"
                        data-aos-delay="300"
                      >
                        <img
                          src={internationalPartnerships2}
                          alt="International Partnerships"
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div
                className={styles.schools}
                data-aos="fade-up"
                data-aos-delay="400"
              >
                <span className={styles.borderbottom}>
                  KTC Group Operated Schools Global
                </span>
                <img
                  src={internationalPartnerships1}
                  alt="KTC Group Operated Schools Global"
                />
              </div>
            </div>
          </div>

          <div
            className={styles.awards}
            data-aos="fade-up"
            data-aos-delay="500"
          >
            <h3>Awards & Recognition</h3>
            {isMobile ? (
              // Mobile Layout
              <div className={styles.awardsMobileContainer}>
                {awards.map((award, index) => (
                  <div
                    key={index}
                    className={styles.awardItem}
                    data-aos="fade-up"
                    data-aos-delay={550 + index * 50}
                  >
                    <img src={award.image} alt={award.name} />
                    <p>{award.name}</p>
                  </div>
                ))}
              </div>
            ) : (
              // Desktop Layout
              <>
                <div className={styles.awardsGrid}>
                  {awards.slice(0, 4).map((award, index) => (
                    <div
                      key={index}
                      className={styles.awardItem}
                      data-aos="fade-up"
                      data-aos-delay={550 + index * 50}
                    >
                      <img src={award.image} alt={award.name} />
                      <p>{award.name}</p>
                    </div>
                  ))}
                </div>
                <div className={styles.awardsCenter}>
                  {awards.slice(4).map((award, index) => (
                    <div
                      key={index + 4}
                      className={styles.awardItem}
                      data-aos="fade-up"
                      data-aos-delay={650 + index * 50}
                    >
                      <img src={award.image} alt={award.name} />
                      <p>{award.name}</p>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default InternationalPartnership;
